import LinkContent from "features/shared/components/buttons/link-button/styles/LinkContent.styled";
import LinkWrapper from "features/shared/components/buttons/link-button/styles/LinkWrapper.styled";
import StyledLinkButton from "features/shared/components/buttons/link-button/styles/StyledLinkButton.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import styled from "styled-components";

import OutlinedButton from "../../shared/components/buttons/OutlinedButton.styled";
import { FormButtonsProps } from "./FormButtons.styled";

const FormButtons = styled.div<FormButtonsProps>`
  display: ${({ displayInline }) =>
    displayInline === true ? "flex" : "block"};

  ${OutlinedButton} {
    margin-right: ${({ direction }) =>
      direction === "ltr" ? "16px" : "initial"};
    margin-left: ${({ direction }) =>
      direction === "rtl" ? "16px" : "initial"};
  }

  /* none-of-the-above reads as an outlined button here, matching the
     select-file-button's outlined variant instead of a plain text link */
  ${StyledLinkButton} {
    display: block;
    box-sizing: border-box;
    width: 100%;
    margin-top: 16px;
    padding: ${({ theme }) => theme.paddingButton};
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.primaryButton};
    border-radius: ${({ theme }) => theme.borderRadiusButton};
    text-align: center;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primary1opacity40};
      border-color: ${({ theme }) => theme.colors.primary1opacity40};
    }
  }

  ${LinkWrapper}, ${LinkContent} {
    justify-content: center;
    border-bottom: none;
    padding-bottom: 0;
  }

  ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primary1};
  }

  ${StyledLinkButton}:hover ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primaryButtonHover};
  }
`;

export default FormButtons;
